// CORTE 4-D2 — textos del PDF de impresión de stickers en el idioma del dueño.
// Lee el idioma persistido por el i18n context (localStorage avisocar_lang).

const STRINGS = {
  es: {
    locale: "es-PE",
    title: "Instrucciones de Impresión",
    instructions: [
      "1. Imprime este sticker en tamaño 6x6 cm o 7x7 cm para mejor legibilidad.",
      "2. Usa papel adhesivo resistente al agua (vinyl o poliéster).",
      "3. Coloca el sticker en un lugar visible y protegido.",
      "4. Ubicaciones recomendadas: parabrisas interno, ventana lateral.",
      "5. Evita lugares con exposición directa al sol prolongada.",
      "",
      "Tip: Laminar el sticker aumenta su durabilidad.",
    ],
    footer_brand: "AvisoCar.com - Tu conexión segura",
    generated_on: "Generado el",
  },
  en: {
    locale: "en-US",
    title: "Printing Instructions",
    instructions: [
      "1. Print this sticker at 6x6 cm or 7x7 cm for best readability.",
      "2. Use water-resistant adhesive paper (vinyl or polyester).",
      "3. Place the sticker somewhere visible and protected.",
      "4. Recommended spots: inside windshield, side window.",
      "5. Avoid prolonged direct sunlight.",
      "",
      "Tip: Laminating the sticker increases its durability.",
    ],
    footer_brand: "AvisoCar.com - Your secure connection",
    generated_on: "Generated on",
  },
  pt: {
    locale: "pt-BR",
    title: "Instruções de Impressão",
    instructions: [
      "1. Imprima este adesivo em 6x6 cm ou 7x7 cm para melhor legibilidade.",
      "2. Use papel adesivo resistente à água (vinil ou poliéster).",
      "3. Coloque o adesivo em um local visível e protegido.",
      "4. Locais recomendados: para-brisa interno, janela lateral.",
      "5. Evite exposição direta prolongada ao sol.",
      "",
      "Dica: Plastificar o adesivo aumenta sua durabilidade.",
    ],
    footer_brand: "AvisoCar.com - Sua conexão segura",
    generated_on: "Gerado em",
  },
  fr: {
    locale: "fr-FR",
    title: "Instructions d'impression",
    instructions: [
      "1. Imprimez ce sticker en 6x6 cm ou 7x7 cm pour une meilleure lisibilité.",
      "2. Utilisez du papier adhésif résistant à l'eau (vinyle ou polyester).",
      "3. Placez le sticker dans un endroit visible et protégé.",
      "4. Emplacements recommandés : pare-brise intérieur, vitre latérale.",
      "5. Évitez l'exposition directe et prolongée au soleil.",
      "",
      "Astuce : plastifier le sticker augmente sa durabilité.",
    ],
    footer_brand: "AvisoCar.com - Votre connexion sécurisée",
    generated_on: "Généré le",
  },
};

export const pdfStrings = () => {
  let lang = "es";
  try { lang = localStorage.getItem("avisocar_lang") || "es"; } catch (_) { /* ignore */ }
  return STRINGS[lang] || STRINGS.es;
};
